import React from 'react';

const sections = [
  {
    heading: '1. Purpose and legal basis',
    body: [
      `We process personal information only for the purposes listed below. For each type of information we collect, the legal basis is specified in accordance with Article 15(1) of Korea's Personal Information Protection Act (PIPA).`,
      {
        type: 'table',
        headers: [
          'Information collected',
          'Purpose of processing',
          'Legal basis',
        ],
        rows: [
          [
            'Email address, name, country and city of residence, date of birth',
            'Account registration and management; service provision',
            'Performance of contract (Art. 15(1), item 4) or consent (Art. 15(1), item 1)',
          ],
          [
            'Gender (optional)',
            'Service improvement and analytics',
            'Consent (Art. 15(1), item 1)',
          ],
          [
            'Payment information (payment method, currency, transaction ID, etc.)',
            'Payment and refund processing',
            'Performance of contract (Art. 15(1), item 4); legal obligation (Art. 15(1), item 2)',
          ],
          [
            'Phone number; academic and career information (optional)',
            'areer and settlement support (Pathfinder, etc.)',
            'Consent (Art. 15(1), item 1)',
          ],
          [
            'Access logs, cookies, analytics data',
            'Service improvement; prevention of unauthorized use',
            'Legitimate interests (Art. 15(1), item 6) or consent (Art. 15(1), item 1)',
          ],
        ],
      },
    ],
  },
  {
    heading: '2. Who we are',
    body: [
      `Koready provides Korean language, culture, career, and settlement support services for global users.`,
      `· Website: www.ko-ready.com`,
      `· Email: contact@ko-ready.com`,
      `· Privacy officer (개인정보 보호책임자): Hayeon Kwon (권하연)`,
      `· Business name: 오잉랩 (O!ng Lab), registration number 179-45-01005`,
      `· Business address: 경기도 수원시 광교호수공원로 277번길`,
    ],
  },
  {
    heading: '3. Information we collect',
    body: [
      `We collect information in three ways:`,
      `· Information you give us directly (Section 4)`,
      `· Information processed during payment (Section 5)`,
      `· Information collected automatically when you use the site (Section 6)`,
    ],
  },
  {
    heading: '4. How long we keep your information',
    body: [
      `① We delete your personal information as soon as the processing purpose is fulfilled or your account is closed. However, some information must be kept for a set period under Korean law.`,
      ``,
      {
        type: 'table',
        headers: ['Records', 'Retention period', 'Legal basis'],
        rows: [
          [
            'Records of contracts or withdrawal from subscription',
            '5 years',
            'Article 6 of the Enforcement Decree of the Electronic Commerce Act',
          ],
          [
            'Enforcement Decree of the Electronic Commerce Act',
            '5 years',
            'Article 6 of the Enforcement Decree of the Electronic Commerce Act',
          ],
          [
            'Records of consumer complaints or dispute resolution',
            '3 years',
            'Article 6 of the Enforcement Decree of the Electronic Commerce Act',
          ],
          [
            'Records of labeling and advertising',
            '6개월',
            'Article 6 of the Enforcement Decree of the Electronic Commerce Act',
          ],
          [
            'Website access logs',
            '3 months or more',
            'Telecommunications Secrets Protection Act; Security Measures Standards',
          ],
        ],
      },
      ``,
      `② After your account is deleted, any information we are legally required to keep is stored separately from your other personal information. It is not used for any purpose beyond what the law requires.`,
    ],
  },
  {
    heading: '5. Information collected during payment',
    body: [
      `① The Service is available to users aged 18 or older.`,
      `② Koready restricts registration by users under the age of 18 through date-of-birth verification at the time of sign-up.`,
    ],
  },
  {
    heading: '6. Information collected automatically',
    body: [
      `\u00a0① The Company processes personal information only within the scope of the purposes specified in Article 1, and shall provide personal information to third parties solely where the data subject has given consent or a legal basis exists, pursuant to Articles 17 and 18 of PIPA.`,
      ``,
      `② Where personal information is provided to a third party, the Company shall inform the data subject of the recipient, the purpose of provision, the items provided, and the recipient's retention and use period, and shall obtain consent.`,
    ],
  },
  {
    heading: '7. Cookies and similar technologies',
    body: [
      `① For the purposes of service provision, the Company outsources certain personal information processing tasks as set out below, and discloses such arrangements and supervises the processors in accordance with Article 26 of PIPA.`,
      ``,
      {
        type: 'table',
        headers: ['Processor', 'Outsourced work', 'Notes'],
        rows: [
          ['Amazon Web Services', 'Cloud hosting and data storage', 'Seoul'],
          [
            'Eximbay and its payment partners',
            'Payment and refund processing',
            'PayPal involves cross-border processing (see Article 8)',
          ],
          [
            'Google (Google Meet)',
            'Online live session operations',
            'Cross-border processing (see Article 8)',
          ],
          [
            'Google (Analytics 4), Microsoft (Clarity)',
            'Service usage analysis and improvement',
            'Cross-border processing (see Article 8)',
          ],
        ],
      },
      ``,
      `② Outsourcing agreements entered into by the Company shall include provisions governing: prohibition of processing beyond the agreed purpose; technical and administrative protective measures; restrictions on sub-contracting; oversight obligations; and liability for damages. The Company conducts regular supervision of its processors. In the event of any change to a processor or the scope of outsourced work, such changes shall be disclosed through this Policy without delay.`,
    ],
  },
  {
    heading: '8. How we use personal information',
    body: [
      `① The Company's servers (AWS) are located in the Republic of Korea (Seoul region). However, personal information may be processed abroad by the following processors, and the Company discloses such transfers and, where required, obtains consent from data subjects or fulfils applicable statutory requirements pursuant to Article 28-8 of PIPA.`,
      ``,
      {
        type: 'table',
        headers: [
          'Recipient',
          'Country',
          'Items transferred',
          'Purpose and retention period',
        ],
        rows: [
          [
            'Google LLC',
            'United States, etc.',
            'Access and usage analytics data, session usage information',
            "Service analytics and live session provision / Subject to each service's policy",
          ],
          [
            'Microsoft Corp.',
            'United States, etc.',
            'Usage behavior analytics data',
            "Usability improvement / Subject to each service's policy",
          ],
          [
            'PayPal',
            'United States, etc.',
            'Payment-related information',
            "nternational payment processing / Subject to each service's policy",
          ],
        ],
      },
    ],
  },
  {
    heading:
      '9. Installation, Operation, and Refusal of Cookies and Automatic Collection Devices',
    body: [
      `① The Company uses cookies for service operation and usage analysis, and may collect behavioral data through Google Analytics 4 and Microsoft Clarity.`,
      ``,
      `② Users may refuse to store cookies through their browser settings; however, doing so may result in restrictions on the use of certain services.`,
      ``,
      `③ The Company shall implement a consent mechanism, such as a cookie consent banner, to enable users to decide whether to consent to the collection of behavioral information through analytics tools.`,
    ],
  },
  {
    heading: '10. Rights of Data Subjects and How to Exercise Them',
    body: [
      `① Data subjects may request access to, correction or deletion of, suspension of processing of, or withdrawal of consent for their personal information at any time.`,
      ``,
      `② Upon receipt of a request for access to personal information, the Company shall notify the data subject within 10 days as to whether access will be granted. Requests for correction or deletion (Article 36 of PIPA) and requests for suspension of processing (Article 37 of PIPA) shall be handled within the timeframes prescribed by applicable law.`,
      ``,
      `③ Rights may be exercised via contact@ko-ready.com or through Settings > Delete account. The Company shall take action after completing identity verification. Where a request is made through an authorized representative, a power of attorney must be submitted.`,
    ],
  },
  {
    heading:
      '11. Payment processing through Eximbay and related providers',
    body: [
      `· Payments are processed by Eximbay and its supported payment partners.`,
      `· Korean cards are processed in KRW. Overseas cards and PayPal are processed in USD.`,
      `· These providers process your payment details under their own privacy policies.`,
      `· Koready receives payment results (such as status and transaction ID), not your full card number.`,
    ],
  },
  {
    heading: '12. Email and service notifications',
    body: [
      `We send service emails such as:`,
      `· Booking and purchase confirmations`,
      `· Waitlist offers (when a seat opens for you)`,
      `· Payment and refund updates`,
      `· Workshop schedule information`,
      `· Important service notices`,
      `· Replies to your questions`,
      `These are part of the service, so they are sent to all users.`,
      `We send these emails from our own servers.`,
    ],
  },
  {
    heading: '13. Analytics tools: Google Analytics 4 and Microsoft Clarity',
    body: [
      `We plan to use Google Analytics 4 (GA4) and Microsoft Clarity to:`,
      `· Understand visitor numbers and how pages are used`,
      `· See where users have problems or leave`,
      `· Improve usability and fix errors`,
      `· Understand payment conversion`,
      `These tools use cookies and may process data on servers outside Korea.`,
      `Analytics data is used in a form that does not directly identify you.`,
    ],
  },
  {
    heading: '14. International users and cross-border processing',
    body: [
      `Koready is based in the Republic of Korea, and our users live around the world.`,
      `· Your information is processed in Korea.`,
      `· Our servers (AWS) are located in Korea (Seoul region).`,
      `· Some service providers may process data in other countries: Google (Analytics, Meet), Microsoft (Clarity), and PayPal.`,
    ],
  },
  {
    heading: '15. Amendments to this Policy',
    body: [
      `This Policy may be revised in accordance with changes in laws or regulations, or changes to the Company's services. In the event of amendments unfavorable to users, the Company shall provide advance notice no less than 30 days prior to the effective date via email or site announcement. For all other amendments, notice shall be provided no less than 7 days prior to the effective date.`,
    ],
  },
];

/** 정책 문서 한 버전. PolicyDocument가 레지스트리를 통해 읽어 렌더링한다. */
export default {
  title: 'Privacy Policy',
  lastUpdated: 'July 17, 2026',
  effectiveDate: '2026-07-17',
  sections,
};
